export const DIALOG_TYPE_ADD = 0;
export const DIALOG_TYPE_EDIT = 1;

export const PASSWORD_RESET_ONE = 1;
export const PASSWORD_RESET_BATCH = 2;
export const PASSWORD_RESET_ALL = 3;

export const TAG_UNCLASSIFIED = 'Unclassified';
